import React from 'react';
import { useForm } from 'react-final-form-hooks';
import { AuthenticationRoot, FormControlsWrapper } from './styled';
import { TextField } from 'ds/components/input/TextField';
import { Button } from 'ds/components/button';
import { useLocale } from 'locale';
import { AuthenticationField } from './types';
import { noop } from 'lodash';
import Spinner from 'components/widget/prices/prices-table/tables/history/affiliation/Spinner';

interface AuthenticationEmailFormProps {
  email: string;
  submitText: string;
  isEmailValid: boolean;
  dirtyFields: Set<AuthenticationField>;
  smallWidthSubmitButton?: boolean;
  onEmailChange(e: React.ChangeEvent<HTMLInputElement>): void;
  onSetDirty: (field: AuthenticationField) => void;
  onSubmit: () => void;
  isLoading: boolean;
  fullWidth?: boolean;
}

export const AuthenticationEmailForm: React.FC<AuthenticationEmailFormProps> = (props) => {
  const {
    email,
    submitText,
    isEmailValid,
    dirtyFields,
    smallWidthSubmitButton,
    onEmailChange,
    onSetDirty,
    onSubmit,
    isLoading,
    fullWidth,
  } = props;

  const { t } = useLocale();
  const { handleSubmit } = useForm({ onSubmit });

  return (
    <AuthenticationRoot fullWidth={fullWidth}>
      <form noValidate onSubmit={isLoading ? noop : handleSubmit}>
        <TextField
          data-auto="signin-email-field"
          type="email"
          fullWidth
          onChange={onEmailChange}
          value={email}
          placeholder={t('authentication.emailPlaceholder')}
          hasError={!isEmailValid && dirtyFields.has('email')}
          errorMessage={t('authentication.emailInvalidMessage')}
          onBlur={() => onSetDirty('email')}
        />
        <FormControlsWrapper smallWidth={smallWidthSubmitButton}>
          <Button
            data-auto="authentication-submit-button"
            fullWidth
            size="extraLarge"
            disabled={isLoading}
            style={isLoading ? { lineHeight: 0 } : undefined}
          >
            {isLoading ? <Spinner /> : submitText}
          </Button>
        </FormControlsWrapper>
      </form>
    </AuthenticationRoot>
  );
};
